<span *ngIf="isAndroid()" class="fa fa-android fa-lg"> </span>
<span *ngIf="isIOS()" class="fa fa-apple fa-lg"> </span>
